module.exports = "//d274d294w9cx2v.cloudfront.net/bac79ef42d9f3f59576400a7e292a6d402156304/images/photo-couple.png";